import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
  faTwitter
} from '@fortawesome/free-brands-svg-icons';
import {
  faArrowUp,
  faDownload,
  faEnvelope,
  faMapMarkerAlt,
  faPhone
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate, Link } from 'react-router-dom';
import wordmarkSrc from '../../assets/images/word_mini.svg';
import RamdanUI from './RamdanUI';

const year = new Date().getFullYear();

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const Footer = () => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate('/apk-viewer');
  };

  return (
    <footer className="modern-footer">


      <div className="footer-content-wrapper">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-col brand-col">
            <div className="footer-logo-box">
              <img src={wordmarkSrc} alt="EMt7any Logo" className="footer-logo-img" />
            </div>
            <p className="footer-desc">
              منصتك التعليمية الذكية الأولى. نقدم تجربة تعليمية متكاملة تجمع بين التكنولوجيا الحديثة والخبرة الأكاديمية لضمان تفوقك.
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/share/1F5VNxwZ4q/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col links-col">
            <h3>روابط سريعة</h3>
            <ul className="footer-links-list">
              <li><Link to="/" onClick={scrollToTop}>الرئيسية</Link></li>
              <li><Link to="/about" onClick={scrollToTop}>من نحن</Link></li>
              <li><Link to="/services" onClick={scrollToTop}>خدماتنا</Link></li>
              <li><Link to="/blogs" onClick={scrollToTop}>المدونة</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-col contact-col">
            <h3>معلومات التواصل</h3>
            <ul className="contact-list">
              <li>
                <FontAwesomeIcon icon={faEnvelope} className="icon" />
                <span>emthanyplatform@gmail.com</span>
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} className="icon" />
                <span>+201554147681</span>
              </li>
              <li>
                <FontAwesomeIcon icon={faMapMarkerAlt} className="icon" />
                <span>القاهرة، مصر</span>
              </li>
            </ul>
          </div>

          {/* App Download */}
          <div className="footer-col download-col">
            <h3>حمل التطبيق</h3>
            <p>تجربة تعليمية أفضل في جيبك. حمل التطبيق الآن للمعلمين والطلاب.</p>
            <button
              className="download-app-btn"
              onClick={handleNavigate}
              aria-label="Download App"
            >
              <div className="btn-icon">
                <FontAwesomeIcon icon={faDownload} />
              </div>
              <div className="btn-text">
                <span className="small">متاح الآن</span>
                <span className="large">حمل التطبيق</span>
              </div>
            </button>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            <p>جميع الحقوق محفوظة منصة امتحاني &copy; {year}</p>
          </div>
          <button className="scroll-top-btn" onClick={scrollToTop} aria-label="Back to Top">
            <FontAwesomeIcon icon={faArrowUp} />
          </button>
        </div>
      </div>

      {/* <RamdanUI /> */}

      <style jsx>{`
        .modern-footer {
          position: relative;
          background: #fff;
          color: #0f172a;
            font-family: "Zain", sans-serif;
          overflow: hidden;
          margin-top: auto;
          border-top: 1px solid rgba(15,23,42,0.06);
        }

        .footer-wave-container {
          position: absolute;
          top: -1px;
          left: 0;
          width: 100%;
          line-height: 0;
          transform: rotate(180deg);
        }

        .footer-wave {
          position: relative;
          display: block;
          width: calc(100% + 1.3px);
          height: 80px;
        }

        .footer-content-wrapper {
          padding: 120px 5% 40px;
          max-width: 1400px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1.5fr;
          gap: 40px;
          margin-bottom: 60px;
        }

        .footer-col h3 {
          font-size: 1.2rem;
          font-weight: 700;
          margin-bottom: 24px;
          position: relative;
          display: inline-block;
          color: #0f172a;
        }

        .footer-col h3::after {
          content: '';
          position: absolute;
          bottom: -8px;
          right: 0;
          width: 40px;
          height: 3px;
          background: #FFE066;
          border-radius: 2px;
        }

        /* Brand Column */
        .brand-col .footer-logo-box {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
        }

        .footer-logo-img {
          height: 40px;
        }

        .footer-brand-name {
          font-size: 1.8rem;
          font-weight: 800;
          margin: 0;
          color: white;
        }

        .footer-desc {
          color: #64748b;
          line-height: 1.7;
          margin-bottom: 24px;
          font-size: 0.95rem;
          max-width: 350px;
        }

        .social-links {
          display: flex;
          gap: 12px;
        }

        .social-links a {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #f8fafc;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #64748b;
          transition: all 0.3s ease;
          border: 1px solid rgba(15,23,42,0.08);
          font-size: 1.1rem;
        }

        .social-links a:hover {
          background: white;
          color: #7a6ad8;
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(0,0,0,0.2);
        }

        /* Links Column */
        .footer-links-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-links-list li {
          margin-bottom: 12px;
        }

        .footer-links-list a {
          color: #64748b;
          text-decoration: none;
          transition: all 0.2s;
          display: inline-block;
          font-size: 0.95rem;
        }

        .footer-links-list a:hover {
          color: #FFE066;
          transform: translateX(-5px);
        }

        /* Contact Column */
        .contact-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .contact-list li {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
          color: #64748b;
          font-size: 0.95rem;
        }

        .contact-list .icon {
          color: #6366f1;
          font-size: 1.1rem;
          min-width: 20px;
        }

        /* Download Column */
        .download-col p {
          color: #64748b;
          margin-bottom: 20px;
          font-size: 0.95rem;
        }

        .download-app-btn {
          background: #f8fafc;
          border: 1px solid rgba(15,23,42,0.1);
          border-radius: 12px;
          padding: 12px 20px;
          display: flex;
          align-items: center;
          gap: 15px;
          cursor: pointer;
          transition: all 0.3s ease;
          width: 100%;
          max-width: 250px;
          color: #0f172a;
        }

        .download-app-btn:hover {
          background: white;
          color: #7a6ad8;
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.15);
        }

        .btn-icon {
          font-size: 1.8rem;
        }

        .btn-text {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .btn-text .small {
          font-size: 0.75rem;
          opacity: 0.8;
          margin-bottom: 2px;
        }

        .btn-text .large {
          font-size: 1.1rem;
          font-weight: 700;
        }

        /* Footer Bottom */
        .footer-bottom {
          border-top: 1px solid rgba(15,23,42,0.06);
          padding-top: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .copyright p {
          margin: 0;
          color: #94a3b8;
          font-size: 0.9rem;
        }

        .scroll-top-btn {
          width: 45px;
          height: 45px;
          border-radius: 12px;
          background: #f8fafc;
          border: 1px solid rgba(15,23,42,0.1);
          color: #64748b;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s;
        }

        .scroll-top-btn:hover {
          background: #FFE066;
          color: #1d1d1f;
          transform: translateY(-3px);
        }

        @media (max-width: 1024px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr;
            gap: 30px;
          }
        }

        @media (max-width: 600px) {
          .footer-grid {
            grid-template-columns: 1fr;
            text-align: center;
          }

          .footer-col h3::after {
            right: 50%;
            transform: translateX(50%);
          }

          .brand-col .footer-logo-box {
            justify-content: center;
          }
          
          .social-links {
            justify-content: center;
          }

          .contact-list li {
            justify-content: center;
          }

          .download-app-btn {
            margin: 0 auto;
          }

          .footer-bottom {
            flex-direction: column-reverse;
            gap: 20px;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
